module.exports = __webpack_public_path__ + "media/PAG87-04.faa85acc.mp3";